export enum ItemStatsStatusFlag{
  unblocked = 0,
  blocked = 1,
  inactive = 2
}
